import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import aboutMePhoto from "../assets/images/AboutMePortrait.jpg";
import slideOnePhoto from "../assets/images/airplanes.jpg";
import slideTwoPhoto from "../assets/images/gunstore.jpg";
import slideThreePhoto from "../assets/images/construction.jpg";
import slideFourPhoto from "../assets/images/school.jpg";
import slideFivePhoto from "../assets/images/walking.jpg";

const AboutPage = () => {
  const carouselSettings = {
    dots: true,
    infinite: true,
    speed: 600,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3200,
    arrows: false
  };

  return (
    <div className="page-shell internal-page">
      <section className="page-hero">
        <p className="section-kicker">About Brian</p>
        <h1>Meet your fellow conservative.</h1>
        <p>
          Brian Hodgers has spent his life building businesses, raising a family, and serving the
          Brevard County community he now wants to represent in Tallahassee.
        </p>
      </section>

      <section className="content-panel">
        <div className="two-column-layout">
          <div className="story-copy">
            <p>
              Brian Hodgers is a lifelong conservative and native Floridian with a strong commitment
              to freedom, opportunity, and the practical values that have helped make Florida a model
              for the rest of the country.
            </p>
            <p>
              He began his career in his family's gas station and service garage, later owned and
              managed gas stations and convenience stores, then built businesses in real estate,
              insurance, and small aircraft sales. That private-sector experience shapes his view that
              government should support growth, not burden it.
            </p>
            <p>
              Brian has also invested deeply in the local community through service on the Brevard
              County Marine Advisory Board, the Planning and Zoning Board, the Citizens Property
              Insurance Market Accountability Advisory Board, and multiple business and civic
              organizations throughout the Space Coast.
            </p>
          </div>
          <div className="portrait-card">
            <img src={aboutMePhoto} alt="Brian Hodgers portrait" className="bio-image portrait-large" />
            <div className="portrait-card-copy">
              <h2>Grounded in family and service</h2>
              <p>
                Brian and his wife Susan are active advocates for better schools, stronger parental
                involvement, and preserving Florida's promise for the next generation.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="content-panel">
        <div className="panel-heading">
          <p className="section-kicker">Why he is running</p>
          <h2>Keep Florida affordable, safe, and prosperous.</h2>
        </div>
        <div className="split-emphasis">
          <div className="story-card">
            <h3>What must be protected</h3>
            <p>
              Florida's success was built on freedom, hard work, accountability, and local communities
              that still expect common sense from their leaders.
            </p>
          </div>
          <div className="story-card">
            <h3>What must be fixed</h3>
            <p>
              Population growth, higher costs, strained infrastructure, and pressure on natural resources
              demand conservative solutions that do not expand government or raise taxes.
            </p>
          </div>
        </div>
        <p className="section-body">
          Brian believes those challenges can be met through disciplined budgeting, stronger local
          infrastructure, better stewardship of Brevard's waterways, school choice, and a continued
          defense of the constitutional freedoms that make Florida distinct.
        </p>
      </section>

      <section className="content-panel media-panel">
        <div className="panel-heading">
          <p className="section-kicker">Life in Brevard</p>
          <h2>Business, aviation, family, and community.</h2>
        </div>
        <Slider {...carouselSettings}>
          {[slideOnePhoto, slideTwoPhoto, slideThreePhoto, slideFourPhoto, slideFivePhoto].map((image, index) => (
            <div key={image} className="campaign-slide">
              <img src={image} alt={`Brian Hodgers community gallery ${index + 1}`} className="campaign-slide-image" />
            </div>
          ))}
        </Slider>
      </section>
    </div>
  );
};

export default AboutPage;
